// app/components/ConditionalHeader.tsx
'use client'
import React from 'react'
import { usePathname } from 'next/navigation'
import { Header } from './Header'

type ConditionalHeaderProps = {
  /** baby: true on nin.in / www.nin.in: root `/` is rewritten to /nin */
  isOrgHost?: boolean
}

function ConditionalHeader({ isOrgHost = false }: ConditionalHeaderProps) {
  const pathname = usePathname()

  // baby: nin.in / www.nin.in is marketing only: never show trading chrome,
  // baby: including when a path matches app/[symbol] (terminal lives on t.nin.in).
  if (isOrgHost) return null

  // baby: Hide trading terminal chrome on marketing / product landings.
  const hideHeader =
    pathname === '/nin' ||
    pathname!.startsWith('/nin/') ||
    pathname!.includes('/chart') ||
    pathname === '/home' ||
    pathname!.startsWith('/home/') ||
    pathname!.includes('/flutter-chat') ||
    pathname!.includes('/backtest') ||
    pathname!.includes('/smart-wallet') ||
    pathname!.includes('/baskets') ||
    pathname!.includes('/historicals') ||
    pathname!.includes('/options-builder') ||
    pathname!.includes('/sentiment') ||
    pathname!.includes('/tax-report') ||
    pathname!.includes('/auth/') ||
    pathname!.includes('/x/') ||
    pathname!.includes('/ningenie') ||
    pathname!.includes('/ningenie/') ||
    pathname!.includes('/mobile-chat-viewer-simple') ||
    pathname!.includes('/ningenie/mobile-chat-viewer-simple/') ||
    pathname!.includes('/ninx') ||
    pathname!.includes('/ninx/') ||
    pathname!.includes('/nincrew') ||
    pathname === '/ninxl' ||
    pathname!.startsWith('/ninxl/') ||
    pathname === '/nink' ||
    pathname!.startsWith('/nink/') ||
    pathname === '/cms' ||
    pathname!.startsWith('/cms/') ||
    pathname!.startsWith('/learn/') ||
    pathname!.startsWith('/blog/')

  if (hideHeader) return null

  return <Header />
}

export default React.memo(ConditionalHeader)
export { ConditionalHeader as Header }
